import { Pipe, PipeTransform, inject, SecurityContext } from '@angular/core';
import { marked } from 'marked';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'markedHtml',
  standalone: true
})
export class MarkedHtmlPipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);
  constructor() {
    // Treat single newlines as line breaks so strings containing "\n" render as new lines
    try {
      marked.setOptions({ breaks: true });
    } catch (e) {
      // ignore if marked doesn't support setOptions in this environment
    }
  }

  transform(value: string): string {
    if (!value) return '';
    const rawHtml = marked.parse(value || '');
    const sanitized = this.domSanitizer.sanitize(SecurityContext.HTML, rawHtml);
    return sanitized || '';
  }
}
